import logger from './logger';

export const logFetchError = async (
  response: Response,
  message: string
): Promise<void> => {
  const errorBody = await response.clone().text();
  logger.error(
    { url: response.url, status: response.status, response: errorBody },
    `[network_error] ${message}`
  );
};
